import React from 'react';
import PageShell, { PageHeader, Flourish } from '../common/PageShell';
import { colors, highlight, layout, space, type } from '../../styles/tokens';

const Section = ({ title, mark, children }) => (
  <section style={{ marginBottom: space[6] }}>
    {title && (
      <h2 style={{ ...type.h2, fontSize: '20px', marginBottom: space[2] }}>
        {title}
        <Flourish tone={colors.sageLight}>{mark}</Flourish>
      </h2>
    )}
    <div style={{ ...type.body, maxWidth: layout.prose }}>{children}</div>
  </section>
);

const Row = ({ term, children }) => (
  <p style={{ marginBottom: space[1] }}>
    <em>{term}</em> — {children}
  </p>
);

const BeyondCodePage = () => (
  <PageShell>
    <PageHeader title="Beyond Code" subtitle="Life outside the terminal" flourish="☼" />

    <p style={{ ...type.body, fontSize: '18px', maxWidth: layout.prose, marginBottom: space[6] }}>
      I think taste comes from somewhere, and <span style={highlight}>diverse experiences</span>{' '}
      make better product people. Here's what shapes my perspective beyond the screen.
    </p>

    <Section title="Interests" mark="✦">
      <Row term="Cooking">Fun &amp; experimental destresser and always a rewarding experience</Row>
      <Row term="Baking">Same instinct as cooking, far less room to improvise</Row>
      <Row term="Reading">Philosophy, horror, sci-fi</Row>
      <Row term="Investing">Recently started, don't know what I'm doing just yet</Row>
      <Row term="Soccer">Club and pickup, for fun nowadays</Row>
      <Row term="Rock Climbing">Newer to it, and worse at it than I'd like to be</Row>
      <Row term="Legos">Genuinely one of the best ways I know to shut my brain off</Row>
    </Section>

    <Section title="Family" mark="♥">
      <p>
        Even though I'm living far from home, my <em>family</em> continues to be one of the most
        important parts of my life. I make it a priority to stay <em>connected</em>, whether it's
        through late-night calls, sharing small updates, or celebrating milestones from afar. They
        remind me of where I come from and keep me <em>grounded</em>, no matter where I am.
      </p>
    </Section>

    <Section title="Favorite Resources" mark="※">
      <Row term="Creators">Mumbo Jumbo, Kurzgesagt, Tommy G</Row>
      <Row term="Books">"Why Fish Don't Exist", "Blood Meridian", "The Long Walk"</Row>
      <Row term="Movies">Nope, Parasite, The Dark Knight</Row>
      <Row term="Video Games">Elden Ring, TFT, Sekiro, Bloodborne</Row>
    </Section>

    <Section title="My Recent Jams" mark="◆">
      <div style={{ ...type.meta, fontSize: '15px', color: colors.ink, lineHeight: 2 }}>
        <div>I Want You // Marvin Gaye</div>
        <div>If // Brent Faiyaz</div>
        <div>Earrings // Malcom Todd</div>
        <div>Wanna Know // Dave &amp; Drake</div>
        <div>New Person, Same Old Mistakes // Tame Impala</div>
      </div>
    </Section>
  </PageShell>
);

export default BeyondCodePage;
